// File: frontend/src/components/pageContent/PageContent.jsx

import React from 'react';
import Auth from '../auth/Auth';
import Register from '../register/Register';
import '../pageContent/PageContent.css';
import Home from '../home/Home';
import ContactForm from '../contactForm/ContactForm';
import Login from '../login/Login';
import PolitiqueManager from '../politique/PolitiqueManager';
import PolitiqueConsulter from '../politique/PolitiqueConsulter';
import PolitiqueCreer from '../politique/PolitiqueCreer';
import SectionManager from '../sections/SectionManager';
import SectionConsulter from '../sections/SectionConsulter';
import SectionCreer from '../sections/SectionCreer';
import ProfilePage from '../profilepage/ProfilePage';
import AdminHomeConfig from '../admin/AdminHomeConfig';

const PageContent = React.memo(({ activePage }) => {
  return (
    <div className="content" key={activePage}>
      {activePage === 'home' && <Home />}
      {activePage === 'admin-home-config' && <AdminHomeConfig />}
      {activePage === 'auth' && <Auth />}
      {activePage === 'register' && <Register />}
      {activePage === 'contact' && <ContactForm />}
      {activePage === 'login' && <Login />}

      {activePage === 'politique' && <PolitiqueManager />}  {/* Gérer politique */}
      {activePage === 'politique-consulter' && <PolitiqueConsulter />}    {/* Consulter politique */}
      {activePage === 'admin-politique' && <PolitiqueCreer />}   {/* Créer politique */}

      {activePage === 'culturel' && (
        <SectionManager category="culturel" managerTitle="GESTION CULTUREL" />
      )}
      {activePage === 'culturel-consulter' && (
        <SectionConsulter
          category="culturel"
          sectionTitle="Culturel"
          emptyLabel="Aucun contenu culturel"
        />
      )}
      {activePage === 'admin-culturel' && (
        <SectionCreer category="culturel" sectionTitle="Culturel" />
      )}

      {activePage === 'economie' && (
        <SectionManager category="economie" managerTitle="GESTION ÉCONOMIE" />
      )}
      {activePage === 'economie-consulter' && (
        <SectionConsulter
          category="economie"
          sectionTitle="Économie"
          emptyLabel="Aucun contenu économie"
        />
      )}
      {activePage === 'admin-economie' && (
        <SectionCreer category="economie" sectionTitle="Économie" />
      )}

      {activePage === 'sport' && (
        <SectionManager category="sport" managerTitle="GESTION SPORT" />
      )}
      {activePage === 'sport-consulter' && (
        <SectionConsulter
          category="sport"
          sectionTitle="Sport"
          emptyLabel="Aucun contenu sport"
        />
      )}
      {activePage === 'admin-sport' && (
        <SectionCreer category="sport" sectionTitle="Sport" />
      )}

      {activePage === 'profilepage' && <ProfilePage />}
    </div>
  );
});

export default PageContent;
